// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import styles from './TemplateCard.module.scss'

export const TemplateCard = ({ children, onClick, isActive, isDisabled }) => (
  <button
    className={cx(styles.card, { [styles.active]: isActive })}
    disabled={isDisabled}
    {...{ onClick }}
  >
    <span className={styles.content}>{children}</span>
  </button>
)
